module.exports = __webpack_public_path__ + "static/media/onboarding.8f25dc96.svg";